import { Component, ViewChild } from '@angular/core';
import { DeprecatedConfirmationDialogComponent, DeprecatedModalFormComponent } from '@app/components';
import { EmployeeModuleMenuService } from '@app/modules/employees/services/employee-module-menu.service';
import { OffboardingReminderForm } from '@app/modules/forms/employees/components';
import { MenuColumnItem } from '@app/modules/table/interfaces/menu-column-item.interface';
import { AuthService } from '@app/services/auth.service';
import { NotifyService } from '@app/services/notify.service';
import { IndexView } from '@common/views';
import { OffboardingReminderTable } from '@employees/services/tables/offboarding-reminder/offboarding-reminder.table';
import { BaseForm } from '@forms/base.form';
import { OffboardingReminder } from '@models/employee/offboarding-reminder.model';

@Component({
    templateUrl: './offboarding-index.template.html',
    styleUrls: ['./offboarding-index.style.scss'],
})
export class OffboardingIndexView extends IndexView {
    @ViewChild('confirmationDialog', { static: true }) confirmationDialog: DeprecatedConfirmationDialogComponent;
    @ViewChild('editReminderModal', { static: true }) editReminderModal: DeprecatedModalFormComponent;
    @ViewChild('editReminderForm', { static: true }) editReminderForm: OffboardingReminderForm;

    isLoading = false;
    reminders: OffboardingReminder[];

    constructor(
        private notify: NotifyService,
        private auth: AuthService,
        public table: OffboardingReminderTable,
        public employeeModuleMenuService: EmployeeModuleMenuService
    ) {
        super();
        this.table.reload();
    }

    menuAction(event: { menuItem: MenuColumnItem; data: OffboardingReminder }): void {
        const { menuItem, data: reminder } = event;

        switch (menuItem.event) {
            case 'delete':
                this.deleteReminder(reminder);
                break;
            case 'edit':
                this.editReminderForm.setReminder(reminder);
                this.editReminderModal.show();
                break;
        }
    }

    onSave(reminder: OffboardingReminder, form: BaseForm): void {
        this.isLoading = true;

        if (reminder.remindBefore === null) {
            reminder.remindBefore = true;
            reminder.delayDays = 0;
        }

        if (reminder.remindTo === 'colleague') {
            reminder.remindTo = reminder.colleagueId;
        }

        reminder
            .param('company', this.auth.company.id)
            .save()
            .then(() => {
                this.notify.success('employees.settingsOffboarding.created.success');
                this.table.reload();
                this.isLoading = false;
                form.reset();
            })
            .catch(() => {
                this.isLoading = false;
                this.notify.error('employees.settingsOffboarding.created.error');
            });
    }

    onCreate(reminder: OffboardingReminder, form: BaseForm): void {
        this.onSave(reminder, form);
    }

    getRemindTo(reminder: OffboardingReminder): string {
        return !Number.isNaN(+reminder.remindTo) ? 'colleague' : reminder.remindTo;
    }

    deleteReminder(reminder: OffboardingReminder): void {
        this.confirmationDialog.show().then((yes: boolean) => {
            if (yes) {
                this.isLoading = true;
                reminder
                    .param('company', this.auth.company.id)
                    .delete()
                    .then(() => {
                        this.table.reload();
                        this.notify.success('employees.settingsOffboarding.deleted.success');
                        this.isLoading = false;
                    })
                    .catch((err) => {
                        this.notify.error(err.message || 'employees.settingsOffboarding.deleted.error');
                        this.isLoading = false;
                    });
            }
        });
    }
}
